import React, {useEffect, useState} from 'react';
import './BarcodePrint.scss';
import Barcode from "react-barcode";

const BarcodePrint = ({data}) => {

  const [componentData, setComponentData] = useState({
    data: [],
    setting: {}
  });

  useEffect(() => {
    setComponentData({
      data: data?.data?.data,
      setting: data?.data?.dimensions,
    })
  }, [data]);

  const style = `  @media print {
    @page {
      size: landscape !important;
    }
  }`

  try {
    return (
      <div className="mainBarcodePrint">
        <style>{style}</style>
        {componentData?.data?.length > 0 &&
          <ul className={"barcodeList"}
              style={{
                width: `${componentData?.setting?.paperWidth}mm`,
                gridTemplateColumns: `repeat(${componentData?.setting?.barcodeCount}, 1fr)`
              }}>
            {componentData?.data?.map((item, index) =>
              <>
                <li key={index + "boxBarcode"} style={{
                  width: `${componentData?.setting?.barcodeWidth}mm`,
                  height: `${componentData?.setting?.barcodeLength}mm`
                }}>
                  <div className={"show-barcode"}>
                    <Barcode value={item?.productCode}
                             displayValue={false}
                             lineColor={"#000000"}
                             width={0.92}
                             height={18}
                             format={'CODE128'}
                             font={"monospace"}/>
                    <p>{item?.productCode}</p>
                  </div>
                  <h4 style={{fontSize: `${componentData?.setting?.productFont}px`}}>{item?.productName}</h4>
                  <h5>{item?.productColor + " " + item?.productSize}</h5>
                  <div className={"show-price"}>
                    <h6 style={{fontSize: `${componentData?.setting?.priceFont}px`}}>
                      {item?.productPrice + " " + componentData?.setting?.currency}
                    </h6>
                  </div>
                </li>
                {(index + 1) % +componentData?.setting?.barcodeCount === 0 && (
                  <li style={{pageBreakBefore: 'always', gridColumn: '1/-1'}}></li>
                )}
              </>
            )}
          </ul>
        }
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default BarcodePrint;